import { Box, styled } from '@project44/manifest-ds';

export const Item = styled(Box, {
  padding: '$medium',
  '&:not(:first-of-type)': {
    paddingTop: 0,
  },
});

export const List = styled('div', {
  width: '100%',
  marginTop: '$small',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '$small',
});
